<template>
	<div>
		<div class="albums-filter clear media-filter">
			<input class="field" type="text" v-model="filterTitle" :placeholder="$root.i18n.defaults.title">

			<select class="select" v-model="filterYear">
				<option value="" default>{{$root.i18n.defaults.year }}</option>
				<option :value="year" v-for="year in $root.years">{{year}}</option>
			</select>

			<select class="select" v-model="filterCategory">
				<option value="" default>{{$root.i18n.defaults.category }}</option>
				<option :value="id" v-for="( category, id ) in $root.categories">{{category}}</option>
			</select>
		</div>

		<hr>

		<ul class="list-albums" v-if="albums.length">
			<li v-for="album in albums">
				<a :href="album.href">
					<span v-html="album.image"></span>
					<span>{{album.title}}</span>
				</a>
			</li>
		</ul>

		<p v-else>
			{{$root.i18n.noAlbums}}
		</p>
	</div>
</template>

<script>

import _ from 'lodash';

export default {
	name : 'album-listing',

	data() {
		return ( {
			baseAlbums : this.$root.albums,
			filterTitle      : this.$root.filters.title,
			filterYear       : this.$root.filters.year,
			filterCategory   : this.$root.filters.category,
		} );
	},

	computed : {
		albums() {
			return this.baseAlbums.filter( album => {
				return album.show;
			} );
		},

		filters() {
			return {
				title      : new RegExp( this.filterTitle, 'ig' ),
				year       : this.filterYear,
				categories : this.filterCategory,
			}
		}
	},

	methods : {
		filterAlbums() {
			this.baseAlbums.map( album => {
				let shows = [];
				
				Object.entries( this.filters ).map( filter => {
					let key   = filter[0];
					let value = filter[1];
					
					let show = false;

					if ( ! value ) {
						show = true;
					} else if ( typeof ( album[ key ] ) === 'object' ) {
						show = Object.keys( album[ key ] ).indexOf( value ) > -1;
					} else if ( typeof ( value ) === 'object' ) {
						show = value.test( album[ key ] );
					} else {
						show = album[ key ] == value;
					}
					shows.push( show );
				} );
				
				album.show = shows.indexOf( false) === -1;
			} );
		}
	},

	watch : {
		filterTitle : _.debounce( function(title) {
			this.filterAlbums();
		}, 200 ),

		filterYear( year ) {
			this.filterAlbums();

		},

		filterCategory( category ) {
			this.filterAlbums();
		},
	}
}

</script>


// WEBPACK FOOTER //
// AlbumListing.vue?58498ba6